import React, { createContext, useContext } from 'react';

const PageLoaderActiveContext = createContext(false);

export const useIsPageLoaderActive = (): boolean =>
  useContext(PageLoaderActiveContext);

export const PageLoaderFallback = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const outerLoaderActive = useIsPageLoaderActive();

  if (outerLoaderActive) {
    return null;
  }

  return (
    <PageLoaderActiveContext.Provider value>
      {children}
    </PageLoaderActiveContext.Provider>
  );
};

export default PageLoaderActiveContext;
